module.exports = __webpack_public_path__ + "img/inrIncrease.7a34fee6.svg";